export const classNamePrefix = "plaiceholder";
